module.exports = __webpack_public_path__ + "img/spa_thumbnail.a1f4dca1.jpg";